module.exports = __webpack_public_path__ + "static/media/hall-P9.bb506ba3.svg";